import { BfxInputControlStateEnum } from "../../../../../shared/base-components/models/base-components.enums";

/* Alias BfxInputControlStateEnum */
export const ICNInputControlState = BfxInputControlStateEnum;
export type ICNInputControlState = BfxInputControlStateEnum;

/* AUTOCOMPLETE ENUMS */
export enum ICNAutocompleteMode {
  TYPE,
  CLIENT,
  ACCOUNT,
  CLIENT_TRADER,
  FIXING_SOURCE,
}
export enum ICNAutocompleteFavoriteType {
  CLIENT,
  ACCOUNT,
  CCY_PAIR,
  CCY_PAIR_NDF,
  CCY_PAIR_BMARK,
}
export enum ICNAutocompleteFavoriteItemFormat {
  RAW,
  MODEL,
  DISPLAY,
}

const COLLATOR = new Intl.Collator(new Intl.NumberFormat().resolvedOptions().locale, {
  sensitivity: "base",
});

const ADMIN_NAME = "name";
const ADMIN_ID = "id";
const ADMIN_BOOKING_CODE = "bookingCd";

export const OrderEntryAccountDisplay = {
  NAME: "name",
  ID: "id",
  BOOKING_CODE: "bookingCode",

  parse: (value: string) => {
    if (COLLATOR.compare(OrderEntryAccountDisplay.NAME, value) === 0)
      return OrderEntryAccountDisplay.NAME;
    else if (COLLATOR.compare(OrderEntryAccountDisplay.ID, value) === 0)
      return OrderEntryAccountDisplay.ID;
    else if (COLLATOR.compare(OrderEntryAccountDisplay.BOOKING_CODE, value) === 0)
      return OrderEntryAccountDisplay.BOOKING_CODE;
    else if (COLLATOR.compare(ADMIN_NAME, value) === 0) return OrderEntryAccountDisplay.NAME;
    else if (COLLATOR.compare(ADMIN_ID, value) === 0) return OrderEntryAccountDisplay.ID;
    else if (COLLATOR.compare(ADMIN_BOOKING_CODE, value) === 0)
      return OrderEntryAccountDisplay.BOOKING_CODE;
    else return OrderEntryAccountDisplay.NAME;
  },
} as const;

export const OrderEntryClientDisplay = {
  NAME: "clientName",
  ID: "clientId",
  BOOKING_CODE: "bookingCode",

  parse: (value: string) => {
    if (COLLATOR.compare(OrderEntryClientDisplay.NAME, value) === 0)
      return OrderEntryClientDisplay.NAME;
    else if (COLLATOR.compare(OrderEntryClientDisplay.ID, value) === 0)
      return OrderEntryClientDisplay.ID;
    else if (COLLATOR.compare(OrderEntryClientDisplay.BOOKING_CODE, value) === 0)
      return OrderEntryClientDisplay.BOOKING_CODE;
    else if (COLLATOR.compare(ADMIN_NAME, value) === 0) return OrderEntryClientDisplay.NAME;
    else if (COLLATOR.compare(ADMIN_ID, value) === 0) return OrderEntryClientDisplay.ID;
    else if (COLLATOR.compare(ADMIN_BOOKING_CODE, value) === 0)
      return OrderEntryClientDisplay.BOOKING_CODE;
    else return OrderEntryClientDisplay.NAME;
  },
} as const;
